import { Controller } from "@hotwired/stimulus"
import { grossFromNet } from "../src/f_numbers"

export default class extends Controller {
  static targets = ["amountNet", "tax", "amountGross"]
  static values = { precision: { type: Number, default: 2 } }

  connect() {
    console.log("Payment item tax calculator connected")
    this.debounceTimeout = null
  }

  disconnect() {
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }
  }

  calculate(_event) {
    this.debounceCalculation(() => {
      const netValue = parseFloat(this.amountNetTarget.value)
      const taxValue = parseFloat(this.taxTarget.value)

      if (!taxValue || taxValue <= 0) return

      if (netValue && netValue > 0) {
        const newGrossValue = grossFromNet(netValue, taxValue, 0, null, this.precisionValue)
        this.amountGrossTarget.value = newGrossValue.toFixed(this.precisionValue)
      }
    })
  }

  debounceCalculation(callback, delay = 300) {
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }
    this.debounceTimeout = setTimeout(callback, delay)
  }
}
